// extracted by mini-css-extract-plugin
export default {"base":"TrackTag-module__[local]___07IE1","sherpa":"TrackTag-module__[local]___GaQzz","finance":"TrackTag-module__[local]___-0wQF","bothTracks":"TrackTag-module__[local]___mUqjj"};